import { render, staticRenderFns } from "./CategoryRow.vue?vue&type=template&id=7c90451d&scoped=true&"
import script from "./CategoryRow.vue?vue&type=script&lang=js&"
export * from "./CategoryRow.vue?vue&type=script&lang=js&"
import style0 from "./CategoryRow.vue?vue&type=style&index=0&id=7c90451d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c90451d",
  null
  
)

export default component.exports